export interface Referee {
  id: number,
  firstName: string|null;
  lastName: string|null;
  referenceType: ReferenceTypes;
  emailAddress: string|null;
  contactNumber: string|null;
  jobTitle: string|null;
  organisationName: string|null;
  candidatePosition: string|null;
  startDateMonth: number|null;
  startDateYear: number|null;
  endDateMonth: number|null;
  endDateYear: number|null;
  currentRole: boolean;
  notes: string|null;
  timeKnown: ReferenceTimeKnown|null;
  relationship: string|null;
  status: RefereeStatus;
  refereeLastViewed: string|null;
}

export interface GetReferenceApplicantRequestStatusResult {
  status: string;
  applicantName: string;
  jobTitle: string;
  companyName: string;
  clientEmail: string;
}

export interface GetRefereesResult {
  referees: Referee[];
}

export enum ReferenceTypes {
  Personal = 0,
  Professional = 1
}

export enum ReferenceTimeKnown {
  LessThanOne = 0,
  OneToTwo = 1,
  TwoToThree = 2,
  ThreeToFour = 3,
  FourToFive = 4,
  FiveToSix = 5,
  SixToSeven = 6,
  SevenToEight = 7,
  EightToNine = 8,
  NineToTen = 9,
  MoreThanTen = 10
}

export class ReferenceTimeKnownStrings {
  static TimeKnown: string[] = [
    'Less than 1 year',
    '1-2 years',
    '2-3 years',
    '3-4 years',
    '4-5 years',
    '5-6 years',
    '6-7 years',
    '7-8 years',
    '8-9 years',
    '9-10 years',
    'More than 10 years'
  ]
}

export class MonthStrings {
  static Month: string[] = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'June',
    'July',
    'Aug',
    'Sept',
    'Oct',
    'Nov',
    'Dec',
  ]
}

export enum RefereeStatus {
  AwaitingDetails = 0,
  ReferenceRequested = 1,
  ReferenceCompleted = 2
}

export interface GetTimelineResult {
  applicantName: string;
  timelineItems: TimelineItem[];
}

export interface TimelineItem {
  description: string;
  formattedDate: string;
  date: Date;
}
